module.exports = __webpack_public_path__ + "static/img/img_default_02.40f62242.png";